import useAllAlertsToastsNotifications from '../../../hooks/useAllAlertsToastsNotifications';

const AlertToastsHook = () => {
  useAllAlertsToastsNotifications();
  return <></>;
};

export default AlertToastsHook;
